import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../component/ExamLanding.css"; // Import CSS

const ExamLanding = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [loading, setLoading] = useState(true);

  // Fetch user details from localStorage
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) {
      navigate("/"); // Redirect to login if no user found
    } else {
      setUserName(user.name);
      setLoading(false);
    }
  }, [navigate]);

  if (loading) return <p className="loading-text">Loading...</p>;

  return (
    <div className="landing-container">
      {/* Hero Section */}
      <header className="hero">
        <h1>Welcome, {userName} 🎉</h1>
        <p>Take online exams with real-time results and anti-cheating measures.</p>
      </header>

      {/* Features Section */}
      <section className="features">
        <h2>Why Choose Our Exam Portal?</h2>
        <div className="features-grid">
          <div className="feature-item">
            <h3>🛡️ Secure & Reliable</h3>
            <p>End-to-end encryption with strict security measures.</p>
          </div>
          <div className="feature-item">
            <h3>⚡ Real-Time Results</h3>
            <p>Instant feedback and scoring after each exam.</p>
          </div>
          <div className="feature-item">
            <h3>🚫 Anti-Cheating Mechanism</h3>
            <p>Full-screen mode and browser restrictions to prevent cheating.</p>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works">
        <h2>How It Works?</h2>
        <div className="steps">
          <div className="step">1️⃣ Register & Login</div>
          <div className="step">2️⃣ Select Your Exam</div>
          <div className="step">3️⃣ Start & Complete the Test</div>
          <div className="step">4️⃣ Get Your Results Instantly</div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <p>© 2025 Exam Portal. All Rights Reserved.</p>
      </footer>
    </div>
  );
};

export default ExamLanding;
